import React, { Fragment } from "react";
import { UserContext } from "../Definitions/UserContext";
import { NoRecordsBanner } from '../OopsBanner';
import { utils } from "../../utils/Utils";


export default function RenderBusinessName({ data, layout = "default" }: { data: any, layout: string }) {
    if (data?.isStenciled) {
        const style = {
            maxHeight: "1em",
            overflow: "hidden",
            opacity: 1
        }
        return <div className="stenciled  flex-column gap-small">
            <div className='w-full stencil-item' style={style}>This page contains basic business nick name.</div>
        </div>
    }

    else if (!data || data.length == 0)
        return <NoRecordsBanner message='This page contains basic business nick name' />

    let businessAddress = "";
    let isTwoLine = layout.includes("2lineaddress");

    if (utils.Validate(data.address))
        businessAddress = businessAddress + data.address;

    if (utils.Validate(data.streetNo)) {
        businessAddress = businessAddress + ", " + data.streetNo;
    }

    if (utils.Validate(data.city)){
        if(isTwoLine)
            businessAddress = businessAddress + "<br/>" + data.city;
        else
            businessAddress = businessAddress + ", " + data.city;
    }

    if (utils.Validate(data.stateCode))
        businessAddress = businessAddress + ", " + data.stateCode;

    if (utils.Validate(data.zip))
        businessAddress = businessAddress + " " + data.zip;

    const locationNickName = data.locationNickName;

    let split = layout.split(";");
    let textLayout = split[0];
    let conentLayout = (split.length > 1) ? split[1] : "";

    let text = locationNickName;

    if (conentLayout == "address"||isTwoLine) {
        text = businessAddress;
    }
    else if (conentLayout == "both") {
        text = locationNickName + ",<br/>" + businessAddress;
    }

    switch (textLayout) {

        case "h-1":
            return <h1 className="w-full name-text sub-inherit-color sub-inherit-f" dangerouslySetInnerHTML={{ __html: text }}></h1>
        case "h-2":
            return <h2 className="w-full name-text sub-inherit-color sub-inherit-f" dangerouslySetInnerHTML={{ __html: text }}></h2>
        case "h-3":
            return <h3 className="w-full name-text sub-inherit-color sub-inherit-f" dangerouslySetInnerHTML={{ __html: text }}></h3>
        case "h-4":
            return <h4 className="w-full name-text sub-inherit-color sub-inherit-f" dangerouslySetInnerHTML={{ __html: text }}></h4>
        case "p-1":
            return <p className="vp-1 w-full name-text sub-inherit-color sub-inherit-f" dangerouslySetInnerHTML={{ __html: text }}></p>
        case "p-2":
            return <p className="vp-2 w-full name-text sub-inherit-color sub-inherit-f" dangerouslySetInnerHTML={{ __html: text }}></p>
        case "p-3":
            return <p className="vp-3 w-full name-text sub-inherit-color sub-inherit-f" dangerouslySetInnerHTML={{ __html: text }}></p>
        case "default":
            return <span dangerouslySetInnerHTML={{ __html: text }}></span>
        default:
            return <span dangerouslySetInnerHTML={{ __html: text }}></span> //setting inner to handle special chars and emojies
    }
}
